module.exports = __webpack_public_path__ + "img/intro-bag.3afe8ef1.svg";